export enum TargetEntityTitlesEnum {
  FIZ = 'Физические лица',
}
